module.exports = __webpack_public_path__ + "img/imgXharra-2.6e14b9ed.png";